<!-- `sm` is a fixed 380px for a question and two buttons; `lg` runs to 80% of a wide screen. -->
<mib-modal size="md">
  <span mib-modal-header class="text-mib-branding-900 truncate font-semibold">
    Upload a case video
  </span>

  <!--
   `min-h-0` on every box down to the upload, this label group included: a flex child refuses to
   shrink below its content without it, and the failure is silent - the list simply never scrolls.
  -->
  <div mib-modal-content class="flex min-h-0 flex-col gap-4">
    <div class="flex min-h-0 flex-1 flex-col gap-1.5">
      <span class="shrink-0 text-sm/5 font-medium text-gray-700">Video file</span>

      <!-- The filter is `video/*`, so naming three formats would turn away an AVI we accept. -->
      <mib-upload
        class="min-h-0 flex-1"
        accept="video/*"
        formats="All video formats"
        [maxSize]="noSizeLimit"
        [files]="files()"
        (picked)="picked($event)"
        (removed)="removed($event)"></mib-upload>
    </div>

    <!-- `shrink-0`, or the sentence gives way before the list it sits under. -->
    <p class="shrink-0 text-sm/5 text-gray-500">
      MIA analyzes the audio and video to generate the case report. Processing runs inside your
      Medinbox environment, under your institution's data policy.
    </p>
  </div>

  <!-- `Close` and not `Cancel`: leaving carries the imports on, it never gives them up. -->
  <div mib-modal-footer class="flex justify-end gap-3">
    <button mibButton type="button" theme="secondary" (click)="close()">Close</button>

    @if (started()) {
      <button mibButton type="button" [disabled]="working()" (click)="close()">Done</button>
    }
  </div>
</mib-modal>
